<template>
  <app-layout>
    <Head title="Autoresponder"/>
    <template #header>
      <PageBackHeader :href="route('autoresponder.index')" label="Autoresponders" />
    </template>
    <div class="max-w-7xl mx-auto">

      <div class="w-full p-2 sm:px-6 lg:px-8 pb-8">
        <div class="bg-white shadow-xl sm:rounded-lg p-4 sm:p-6 lg:p-8">

          <autoresponder-form key="dashboard-message-form"/>
        </div>
      </div>
    </div>

  </app-layout>
</template>

<script>
import AutoresponderForm from '../../components/AutoresponderForm';
import AppLayout from '../../Layouts/AppLayout'
import Welcome from '../../Jetstream/Welcome'
import JetButton from '../../Jetstream/Button';

export default {
  components: {
    AutoresponderForm,
    AppLayout,
    Welcome,
    JetButton
  },
  props: {
    
  },
    methods: {
    formatPhoneNumber(phoneNumber) {
      // Remove any non-numeric characters from the phone number.
      phoneNumber = phoneNumber.replace(/[^0-9]/g, "");

      // Check if the phone number is 10 digits long.
      if (phoneNumber.length !== 11) {
        return null;
      }
      // Format the phone number in the (###) ###-#### format.
      return "(" + phoneNumber.substring(1, 4) + ") " + phoneNumber.substring(4, 7) + "-" + phoneNumber.substring(7);
    }
  },
  computed: {
    formattedPhoneNumber() {
      return this.$page.props.auth.user.organization.phone
        ? this.formatPhoneNumber(this.$page.props.auth.user.organization.phone)
        : null;
    }
  }
}


</script>
